import { IconType } from "@/components/Core/AppIcon";

import Entity from "./entity";

export enum NotificationType {
  ACCOUNT_VERIFICATION = "account_verification",
  SECURITY_ALERT = "security_alert",
  DEPOSIT_SUCCESS = "deposit_success",
  WITHDRAWAL_PROCESSED = "withdrawal_processed",
  GAME_RESULT = "game_result",
  BONUS_OFFER = "bonus_offer",
  LIVE_CASINO_UPDATE = "live_casino_update",
  PROMOTION = "promotion",
}

export interface Notification extends Entity {
  userId: string;
  type: NotificationType;
  title: string;
  message: string;
  isRead: boolean;
  metadata?: {
    gameId?: string;
    balanceId?: string;
    amount?: number;
    tableId?: string;
    promoCode?: string;
  };
  priority?: "low" | "medium" | "high" | "urgent";
  expiresAt?: Date;
}

export interface ServerNotification extends Entity {
  userId: string;
  title: string;
  message: string;
  viewed: boolean;
  deleted: boolean;
}

export const NotificationIcons: Record<NotificationType, IconType> = {
  [NotificationType.ACCOUNT_VERIFICATION]: "verified",
  [NotificationType.SECURITY_ALERT]: "security",
  [NotificationType.DEPOSIT_SUCCESS]: "add-circle",
  [NotificationType.WITHDRAWAL_PROCESSED]: "send3",
  [NotificationType.GAME_RESULT]: "add-circle",
  [NotificationType.BONUS_OFFER]: "add-circle",
  [NotificationType.LIVE_CASINO_UPDATE]: "add-circle",
  [NotificationType.PROMOTION]: "promotion",
};
